import React, { useState } from "react";
import { contact } from "../data";
import useReveal from "../hooks/useReveal";

const EMPTY = { name: "", email: "", phone: "", message: "" };

export default function Contact() {
  const [ref, visible] = useReveal();
  const [form, setForm] = useState(EMPTY);
  const [status, setStatus] = useState("idle"); // idle | sending | success | error

  const handleChange = (e) =>
    setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("sending");

    try {
      const res = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
          access_key: contact.web3formsKey,
          subject: "Solicitare ofertă — site LEASEIN",
          from_name: "Site LEASEIN",
          name: form.name,
          email: form.email,
          phone: form.phone,
          message: form.message,
        }),
      });
      const data = await res.json();
      if (data.success) {
        setStatus("success");
        setForm(EMPTY);
      } else {
        setStatus("error");
      }
    } catch (err) {
      setStatus("error");
    }
  };

  return (
    <section className="contact" id="contact">
      <div ref={ref} className={`contact__inner reveal ${visible ? "is-visible" : ""}`}>
        <div className="contact__text">
          <span className="section__kicker">Contact</span>
          <h2>Hai să-ți facem o ofertă</h2>
          <p>
            Spune-ne de câte mașini ai nevoie și pentru ce perioadă, iar noi
            revenim cu o ofertă personalizată.
          </p>
          <ul className="contact__details">
            <li>
              <span>Email</span>
              <a href={`mailto:${contact.email}`}>{contact.email}</a>
            </li>
            <li>
              <span>Telefon</span>
              <span className="contact__phones">
                {contact.phones.map((p, i) => (
                  <a key={i} href={`tel:${p.href}`}>{p.display}</a>
                ))}
              </span>
            </li>
          </ul>
        </div>

        {status === "success" ? (
          <div className="contact__form contact__success">
            <div className="contact__success-icon">
              <svg viewBox="0 0 24 24" width="34" height="34" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <path d="M20 6L9 17l-5-5" />
              </svg>
            </div>
            <h3>Mulțumim!</h3>
            <p>Am primit solicitarea ta. Te contactăm în cel mai scurt timp.</p>
            <button
              type="button"
              className="btn btn--ghost"
              onClick={() => setStatus("idle")}
            >
              Trimite altă solicitare
            </button>
          </div>
        ) : (
          <form className="contact__form" onSubmit={handleSubmit}>
            <label>
              Nume / Companie
              <input
                type="text"
                name="name"
                value={form.name}
                onChange={handleChange}
                placeholder="Numele tău sau al firmei"
                required
              />
            </label>
            <label>
              Email
              <input
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                placeholder="email@companie.ro"
                required
              />
            </label>
            <label>
              Telefon
              <input
                type="tel"
                name="phone"
                value={form.phone}
                onChange={handleChange}
                placeholder="07xx xxx xxx"
              />
            </label>
            <label>
              Mesaj
              <textarea
                name="message"
                rows="4"
                value={form.message}
                onChange={handleChange}
                placeholder="De câte mașini ai nevoie și pe ce perioadă?"
                required
              />
            </label>
            <button type="submit" className="btn btn--primary" disabled={status === "sending"}>
              {status === "sending" ? "Se trimite..." : "Trimite solicitarea"}
            </button>
            {status === "error" && (
              <small className="contact__error">
                Ceva nu a mers. Încearcă din nou sau scrie-ne direct la {contact.email}.
              </small>
            )}
          </form>
        )}
      </div>
    </section>
  );
}
